export enum CommonTranslationKey {
    ADD = "common.add",
    CANCEL = "common.cancel",
    CHANGE_PASSWORD = "common.changePassword",
    CLOSE = "common.close",
    CODE = "common.code",
    COPY_URL = "common.copyUrl",
    CREATE = "common.create",
    CSV_LABEL = "common.csvLabel",
    DATA_DELETED_SUCCESSFULLY = "common.dataDeletedSuccessfully",
    DATA_SAVED_SUCCESSFULLY = "common.dataSavedSuccessfully",
    DELETE = "common.delete",
    DESCRIPTION = "common.description",
    EDIT = "common.edit",
    EXCEL_LABEL = "common.excelLabel",
    FIELD_TOO_LONG = "common.fieldTooLong",
    FILL_OUT_AT_LEAST_ONE = "common.fillOutAtLeastOne",
    FILL_OUT_ITEM_FROM_LIST = "common.fillOutItemFromList",
    FILL_OUT_THIS_FIELD = "common.fillOutThisField",
    KEEP = "common.keep",
    LIST_OF_DISPLAYED_ELEMENTS = "common.listOfDisplayedElements",
    NO = "common.no",
    OK = "common.ok",
    PAGE_NOT_FOUND = "common.pageNotFound",
    PUBLIC = "common.public",
    PRIVATE = "common.private",
    REMOVE = "common.remove",
    SAVE = "common.save",
    SELECT_ALL = "common.selectAll",
    SHOW_DETAIL = "common.showDetail",
    TITLE = "common.title",
    VALUE = "common.value",
    UPDATE = "common.update",
    USER = "common.user",
    WARNING = "common.warning",
    YES = "common.yes",
    SELECT = "common.select",
    STYLES = "common.styles",
}
